/* eslint-disable @typescript-eslint/no-unused-vars, react-hooks/exhaustive-deps */
import React from "react";
import Image_src_banner_300_credit from "../assets/banner-300-credit.png";

const ImageSection: React.FC<{ lang?: "th" | "en" }> = ({ lang = "th" }) => {
  return (
    <div style={{ textAlign: "left", width: "100%" }}><img src={Image_src_banner_300_credit} alt="ทดลองเข้าใช้งานได้ฟรี 300 Credit" style={{ width: "100%", height: "auto", borderRadius: "0px", objectFit: "contain", display: "block" }} /></div>
  );
};

export default ImageSection;
